import { Alert } from "@material-ui/lab";
import React, { useContext } from "react";
import { Route } from "react-router-dom";
import { authInfoContext } from "../context/GlobalState";
import { AuthRouteProps, GlobalContextProps } from "../types";
import LoginDialog from "./LoginDialog";
import { Container } from "@material-ui/core";

function canAccess(pageAccessCode: number, userAccessCode: number): boolean {
  return (pageAccessCode & userAccessCode) !== 0;
}

function LoginAlert(): JSX.Element {
  return (
    <Container maxWidth="sm">
      <Alert variant="outlined" severity="warning" action={<LoginDialog />}>
        您需要先登陆才能访问此页面！
      </Alert>
    </Container>
  );
}

function NotAuthorizedAlert(): JSX.Element {
  return (
    <Container maxWidth="sm">
      <Alert variant="outlined" severity="error">
        您没有权限访问该页面！
      </Alert>
    </Container>
  );
}

export const AuthRoute: React.FC<AuthRouteProps> = ({
  children,
  path,
  pageAccessCode
}) => {
  const context = useContext<GlobalContextProps>(authInfoContext);
  const { authInfo } = context;

  return (
    <Route
      path={path}
      // eslint-disable-next-line react/no-children-prop
      children={(): JSX.Element => {
        if (
          !authInfo.loggedIn ||
          !canAccess(pageAccessCode, authInfo.accessCode)
        ) {
          return authInfo.loggedIn ? <NotAuthorizedAlert /> : <LoginAlert />;
        }
        return children;
      }}
    />
  );
};
